export default __webpack_public_path__ + "static/media/granit_logo-1.e1fb550e.png";